import { ContextApi } from "@donaswap/localization";
import { FooterLinkType } from "../../../components/Footer/types";

export const footerLinks: (t: ContextApi["t"]) => FooterLinkType[] = (t) => [
  {
    label: t("About"),
    items: [
      {
        label: t("Contact"),
        href: "https://docs.donaswap.io/contact-us",
        isHighlighted: true,
      },
      {
        label: t("Brand"),
        href: "https://docs.donaswap.io/brand",
      },
      {
        label: t("Blog"),
        href: "https://blog.donaswap.io/",
      },
      {
        label: t("Community"),
        href: "https://docs.donaswap.io/contact-us/telegram",
      },
      {
        label: t("Litepaper"),
        href: "https://v2litepaper.donaswap.io/",
      },
      {
        label: t("FLAME Emission Projection"),
        href: "https://analytics.donaswap.io/",
      },
      {
        label: t("Terms Of Service"),
        href: "https://donaswap.io/terms-of-service",
      },
    ],
  },
  {
    label: t("Help"),
    items: [
      {
        label: t("Customer Support"),
        href: "https://docs.donaswap.io/contact-us/customer-support",
      },
      {
        label: t("Troubleshooting"),
        href: "https://docs.donaswap.io/help/troubleshooting",
      },
      {
        label: t("Guides"),
        href: "https://docs.donaswap.io/get-started",
      },
    ],
  },
  {
    label: t("Developers"),
    items: [
      {
        label: "Gitlab",
        href: "https://gitlab.com/donaswaptg",
      },
      {
        label: t("Documentation"),
        href: "https://docs.donaswap.io",
      },
      {
        label: t("Bug Bounty"),
        href: "https://docs.donaswap.io/code/bug-bounty",
      },
      {
        label: t("Audits"),
        href: "https://docs.donaswap.io/help/faq#is-donaswap-safe-has-donaswap-been-audited",
      },
      {
        label: t("Careers"),
        href: "https://docs.donaswap.io/hiring/become-a-chef",
      },
    ],
  },
];
